import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { CircleLoader } from 'react-spinners';

const UserList = (props) => {

    const [users, setUsers] = useState([]);
    const [showCode, setShowCode] = useState(false);
    const [nameToRemove, setName] = useState("")
    const [idToRemove, setID] = useState(0);

    const test_get_user_link = "http://localhost:3000/current/companyreps/"
    const production_get_user_link = "https://apple-tree-server.vercel.app/current/companyreps"
    
    const test_remove_user_link = "http://localhost:3000/delete/user"
    const production_remove_user_link = "https://apple-tree-server.vercel.app/delete/user"
    

    const getUser = async () => {
        const user_id = Cookies.get('token_id');

        await axios.post(production_get_user_link, {
            user_id
        })
        .then(response => {
            setUsers(response.data)
            console.log(response.data)
        })
        .catch(error => console.log(error))
    }

    const removeUser = async() => {
        await axios.post(production_remove_user_link, {
            "user_id": idToRemove
        })
        .then((res) => {
            console.log(res)
            alert(nameToRemove + " has been removed")
        })
        .catch((err) => {
            alert(err)
        })
    }

    useEffect(() => {
        getUser();
    }, [])

    
    let count = 0;
    if (users.length == 0) {
        return (
            <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
        )
    }

    if (users[0].registered_user != (Cookies.get('token_first_name') + " " + Cookies.get('token_last_name'))) {
        return (
            <div className='text-center lead'>
                Only company <span className='text-success'>creator</span>  can view
            </div>
        )
    }

    return (
        <div>
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">Remove</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        Remove <span className="fw-light text-danger">{nameToRemove}</span> ? 
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" onClick={() => {
                            removeUser();
                        }}>Confirm</button>
                    </div>
                    </div>
                </div>
            </div>
            <h2 className='text-center display-3'>{users[0].company}</h2>
            <div className='d-flex'>
                <button className='btn btn-outline-primary ms-4' onClick={() => {
                    showCode ? setShowCode(false) : setShowCode(true)
                }}>Reveal code</button>
                
                {
                    showCode &&
                <p className='ms-4 lead text-muted'>{users[0].code}</p>

                }
            </div>

            <table class="table table-bordered table-striped table-hover borded rounded-3 overflow-hidden m-3">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">First name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Position</th>

                    </tr>
                </thead>
                <tbody>
                    { 
                        users.length > 0 &&
                        users.map((user) => {
                            if (user.removed == "true") return;
                            count += 1;
                        
                            return (
                                <tr data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => {
                                    setName(user.first_name + " " + user.last_name)
                                    setID(user.user_id)
                                }}>
                                    <th>{count}</th>
                                    <td>{user.first_name}</td>
                                    <td>{user.last_name}</td>
                                    <td className='text-secondary'>{user.email}</td>
                                    {(user.registered_user == (user.first_name + " " + user.last_name) )? <td className='text-success'>{ user.position} (creator)</td>: <td className='text-info'>{user.position} </td>}
                                    
                                </tr>
                            )
                        })
                    }
                    {/* <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="" style={{
                            color:"OrangeRed"
                        }}>Unpaid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr> */}
                </tbody>
            </table> 
        </div>
        
    );
};

export default UserList;
